import YoutubeIframePlayer from './components/YoutubeIframePlayerComponent';
export default YoutubeIframePlayer;